import { useProducts } from '@gozoki/api'
import { useMemo } from 'react'
import type { MenuOption } from '../../components/containers/MenuOptions'

export const useProductSelectOptions = (): MenuOption[] => {
  const { data: allProducts } = useProducts()

  const activeProducts = useMemo(
    () => allProducts?.filter((product) => product.isActive),
    [allProducts],
  )

  return useMemo(() => {
    const baseProductsChoices: MenuOption[] = []
    const categoriesOptions: Record<number, { label: string; value: number[]; isHelper: true }> = {}
    const negoceOptions: Record<string, { label: string; value: number[]; isHelper: true }> = {}

    activeProducts?.forEach((product) => {
      baseProductsChoices.push({
        label: product.label,
        value: product.id,
      })
      product.categories.forEach((category) => {
        if (!categoriesOptions[category.id]) {
          categoriesOptions[category.id] = {
            label: category.name,
            value: [],
            isHelper: true,
          }
        }
        categoriesOptions[category.id].value.push(product.id)
      })
      if (!negoceOptions[product.negoceType]) {
        negoceOptions[product.negoceType] = {
          label: product.negoceType,
          value: [],
          isHelper: true,
        }
      }
      negoceOptions[product.negoceType].value.push(product.id)
    })

    const allChoices: MenuOption[] = []
    Object.values(categoriesOptions).forEach((category) => {
      allChoices.push(category)
    })
    Object.values(negoceOptions).forEach((negoce) => {
      allChoices.push(negoce)
    })
    baseProductsChoices.forEach((product) => {
      allChoices.push(product)
    })
    return allChoices
  }, [activeProducts])
}
